<template>
    <b-container fluid class="">
        <b-row class="justify-content-between flex-center py-2">
            <b-col cols="12" class="text-center">
                <h3> {{ event.name }} </h3>
            </b-col>
        </b-row>

        <b-row class="w-100 noMargin my-2">
            <b-col cols="4">
                <b-row class="w-100 noMargin my-2" style="height: 100px;">
                    <b-col cols="12" v-for="item in sectorGateReads" class="eventDash noMargin">
                        <h5 class="p-2 text-center">{{item.code}}</h5>
                        <h4 class="px-2 text-center">{{item.total_tickets}}</h4>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="4">
                <b-row class="w-100 noMargin my-2" style="height: 100px;">
                    <b-col cols="12">
                        <vue-draggable-resizable v-for="item in sectorGateReads" v-if="item.position === 8" :w="200" :h="100" :min-height="50" @dragging="onDrag" @resizing="onResize" :parent="true" class="eventDash">
                            <h5 class="p-2 text-center">{{item.code}}</h5>
                            <h4 class="px-2 text-center">{{item.total_tickets}}</h4>
                        </vue-draggable-resizable>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'dashboardEvent',
        data() {
            return {
                totalTickets: 0,
                events: {},
                event: {},
                gateReads: null,
                sectorGateReads: null,
                gateRead: {},
                width: 0,
                height: 0,
                x: 0,
                y: 0
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            onResize: function (x, y, width, height) {
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
            },
            onDrag: function (x, y) {
                this.x = x;
                this.y = y;
            },
            getEvent(){
                this.$axios.get('/events/getById',
                    {
                        params: {
                            id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.event = response.data.data;
                    }
                });
            },
            getGateReads(){
                this.$axios.get('/gateReads',
                    {
                        params: {
                            event_id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.gateReads = response.data.data;
                        this.getTotalTickets();
                    }
                });
            },
            getSectorGateReads(){
                this.$axios.get('/sectorGateReads',
                    {
                        params: {
                            event_id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.sectorGateReads = response.data.data;
                    }
                });
            },
            getTotalTickets(){
                this.totalTickets = 0;
                for(let i = 0; i< this.gateReads.length; i++)
                    this.totalTickets += parseInt(this.gateReads[i].total_tickets);
            },
        },
        created() {

            let self = this;
            this.getEvent();
            this.getGateReads();
            this.getSectorGateReads();
            this.interval = setInterval(function () {
                self.getEvent();
                self.getGateReads();
                self.getSectorGateReads();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>